import { render, staticRenderFns } from "./PoiMiniCardTitle.vue?vue&type=template&id=795d4162&"
import script from "./PoiMiniCardTitle.vue?vue&type=script&lang=ts&"
export * from "./PoiMiniCardTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports